// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* PolicyPages.css — shared styles for PrivacyPolicy and RefundPolicy */

.policy-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1rem;
  font-family: Arial, sans-serif;
}

.policy-card {
  background: #fff;
  border-radius: 12px;
  padding: 2.5rem;
  box-shadow: 0 2px 12px rgba(0,0,0,0.08);
}

.policy-card h1 {
  font-size: 2rem;
  color: #1a1a2e;
  margin-bottom: 0.25rem;
}

.policy-date {
  color: #888;
  font-size: 0.9rem;
  margin-bottom: 2rem;
  border-bottom: 1px solid #eee;
  padding-bottom: 1rem;
}

.policy-card section {
  margin-bottom: 2rem;
}

.policy-card h2 {
  font-size: 1.2rem;
  color: #0056b3;
  margin-bottom: 0.75rem;
  padding-left: 0.75rem;
  border-left: 4px solid #007bff;
}

.policy-card p {
  color: #444;
  line-height: 1.8;
  margin-bottom: 0.75rem;
}

.policy-card ul {
  color: #444;
  line-height: 1.8;
  padding-left: 1.5rem;
  margin-bottom: 0.75rem;
}

.policy-card ul li {
  margin-bottom: 0.4rem;
}

.policy-card a {
  color: #007bff;
  text-decoration: none;
}

.policy-card a:hover {
  text-decoration: underline;
}

.policy-card strong {
  color: #222;
}
`, "",{"version":3,"sources":["webpack://./src/pages/PolicyPages.css"],"names":[],"mappings":"AAAA,uEAAuE;;AAEvE;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb","sourcesContent":["/* PolicyPages.css — shared styles for PrivacyPolicy and RefundPolicy */\n\n.policy-container {\n  max-width: 800px;\n  margin: 0 auto;\n  padding: 2rem 1rem;\n  font-family: Arial, sans-serif;\n}\n\n.policy-card {\n  background: #fff;\n  border-radius: 12px;\n  padding: 2.5rem;\n  box-shadow: 0 2px 12px rgba(0,0,0,0.08);\n}\n\n.policy-card h1 {\n  font-size: 2rem;\n  color: #1a1a2e;\n  margin-bottom: 0.25rem;\n}\n\n.policy-date {\n  color: #888;\n  font-size: 0.9rem;\n  margin-bottom: 2rem;\n  border-bottom: 1px solid #eee;\n  padding-bottom: 1rem;\n}\n\n.policy-card section {\n  margin-bottom: 2rem;\n}\n\n.policy-card h2 {\n  font-size: 1.2rem;\n  color: #0056b3;\n  margin-bottom: 0.75rem;\n  padding-left: 0.75rem;\n  border-left: 4px solid #007bff;\n}\n\n.policy-card p {\n  color: #444;\n  line-height: 1.8;\n  margin-bottom: 0.75rem;\n}\n\n.policy-card ul {\n  color: #444;\n  line-height: 1.8;\n  padding-left: 1.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.policy-card ul li {\n  margin-bottom: 0.4rem;\n}\n\n.policy-card a {\n  color: #007bff;\n  text-decoration: none;\n}\n\n.policy-card a:hover {\n  text-decoration: underline;\n}\n\n.policy-card strong {\n  color: #222;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
